"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpStandardProjects = void 0;
var vue_1 = require("vue");
var Card_1 = require("./../card/Card");
var CardName_1 = require("./../../CardName");
exports.HelpStandardProjects = vue_1.default.component('help-standard-projects', {
    components: {
        Card: Card_1.Card,
    },
    methods: {
        getBasicStandardProjects: function () { return [
            CardName_1.CardName.SELL_PATENTS_STANDARD_PROJECT,
            CardName_1.CardName.POWER_PLANT_STANDARD_PROJECT,
            CardName_1.CardName.ASTEROID_STANDARD_PROJECT,
            CardName_1.CardName.AQUIFER_STANDARD_PROJECT,
            CardName_1.CardName.GREENERY_STANDARD_PROJECT,
            CardName_1.CardName.CITY_STANDARD_PROJECT,
        ]; },
        getExpansionStandardProjects: function () { return [
            CardName_1.CardName.AIR_SCRAPPING_STANDARD_PROJECT,
            CardName_1.CardName.BUILD_COLONY_STANDARD_PROJECT,
            CardName_1.CardName.BUFFER_GAS_STANDARD_PROJECT,
        ]; },
        getFanMadeStandardProjects: function () { return [
            CardName_1.CardName.MOON_COLONY_STANDARD_PROJECT,
            CardName_1.CardName.MOON_MINE_STANDARD_PROJECT,
            CardName_1.CardName.MOON_ROAD_STANDARD_PROJECT,
        ]; },
        getRebalancedStandardProjects: function () { return [
            CardName_1.CardName.BUILD_COLONY_STANDARD_PROJECT_REBALANCED,
        ]; },
    },
    template: "\n    <div class=\"help-standard-projects-container\">\n\n      <h2 v-i18n>Standard Projects</h2>\n      <div class=\"cardbox\" v-for=\"card in getBasicStandardProjects()\">\n        <Card :card=\"{'name': card}\" />\n      </div>\n\n      <h2 v-i18n>Standard Projects from Expansions and Solo Mode</h2>\n      <div class=\"cardbox\" v-for=\"card in getExpansionStandardProjects()\">\n        <Card :card=\"{'name': card}\" />\n      </div>\n\n      <h2 v-i18n>Standard Projects from Moon Expansion</h2>\n      <div class=\"cardbox\" v-for=\"card in getFanMadeStandardProjects()\">\n        <Card :card=\"{'name': card}\" />\n      </div>\n\n      <h2 v-i18n>Rebalanced Standard Project</h2>\n      <div class=\"cardbox\" v-for=\"card in getRebalancedStandardProjects()\">\n        <Card :card=\"{'name': card}\" />\n      </div>\n\n    </div>\n    ",
});
//# sourceMappingURL=HelpStandardProjects.js.map